import { GraphSchema } from '@camelot/server';
import { User } from '@camelot/user';

import { CalendarEntry, calendarEntryProps } from './calendar-entry';

export interface CalendarExternalEvent extends CalendarEntry {
  userId: string;
  user?: User;
}

const props: (keyof CalendarExternalEvent)[] = ['userId', 'user'];

export const calendarExternalEventProps = new GraphSchema<CalendarExternalEvent>(props.concat(calendarEntryProps));
